module.exports = __webpack_public_path__ + "img/cart-empty.89ab1681.png";